// body fade in on load //
$(document.body).fadeIn(1000);

// Add aria-live region for cart announcements
const cartAnnouncement = document.createElement('div');
cartAnnouncement.setAttribute('aria-live', 'polite');
cartAnnouncement.setAttribute('aria-atomic', 'true');
cartAnnouncement.setAttribute('class', 'visually-hidden');
document.body.appendChild(cartAnnouncement);

// Function to announce cart changes
function announceCartChange(message) {
	cartAnnouncement.textContent = message;
}

// Accordion functionality for sub-accordion sections
$(document).ready(function () {
	// Function to handle accordion toggle
	function toggleAccordion($header, $content, isExpanded) {
		if (!isExpanded) {
			// First reset all sub-accordions in other main accordions
			$('.main-accordion-content')
				.not($content)
				.each(function () {
					$(this)
						.find('.sub-accordion-header')
						.removeClass('active')
						.attr('aria-expanded', 'false');
					$(this)
						.find('.sub-accordion-content')
						.css('display', 'none')
						.attr('aria-hidden', 'true');
				});

			// Then close the other main accordions
			$('.main-accordion-header')
				.not($header)
				.removeClass('active')
				.attr('aria-expanded', 'false');
			$('.main-accordion')
				.not($header.closest('.main-accordion'))
				.attr('aria-expanded', 'false');
			$('.main-accordion-content')
				.not($content)
				.slideUp(300)
				.attr('aria-hidden', 'true');
		}

		if (isExpanded) {
			$header.removeClass('active');
			$header.attr('aria-expanded', 'false');
			$header
				.closest('.main-accordion')
				.attr('aria-expanded', 'false');
			$content.slideUp(300).attr('aria-hidden', 'true');

			// Reset all sub-accordions inside this main accordion to closed state
			setTimeout(function () {
				$content
					.find('.sub-accordion-header')
					.removeClass('active')
					.attr('aria-expanded', 'false');
				$content
					.find('.sub-accordion-content')
					.css('display', 'none')
					.attr('aria-hidden', 'true');
			}, 300); // Match the slideUp duration
		} else {
			$header.addClass('active');
			$header.attr('aria-expanded', 'true');
			$header
				.closest('.main-accordion')
				.attr('aria-expanded', 'true');
			$content.slideDown(300).attr('aria-hidden', 'false');
		}
	}

	// Main accordion functionality
	$(document).on(
		'click keydown',
		'.main-accordion',
		function (e) {
			// Only trigger on click, space, or enter
			if (
				e.type === 'keydown' &&
				e.keyCode !== 32 &&
				e.keyCode !== 13
			) {
				return;
			}

			const $accordion = $(this);
			const $header = $accordion.find(
				'.main-accordion-header'
			);
			const $content = $header.next(
				'.main-accordion-content'
			);
			const isExpanded = $header.hasClass('active');

			// Set initial aria-expanded state if not set
			if (!$header.attr('aria-expanded')) {
				$header.attr(
					'aria-expanded',
					isExpanded ? 'true' : 'false'
				);
			}
			if (!$accordion.attr('aria-expanded')) {
				$accordion.attr(
					'aria-expanded',
					isExpanded ? 'true' : 'false'
				);
			}
			if (!$content.attr('aria-hidden')) {
				$content.attr(
					'aria-hidden',
					isExpanded ? 'false' : 'true'
				);
			}

			toggleAccordion($header, $content, isExpanded);

			// If opening the accordion and it was triggered by keyboard, focus the first sub-accordion
			if (!isExpanded && e.type === 'keydown') {
				const $firstNestedHeader = $content
					.find('.sub-accordion-header')
					.first();
				const $firstNestedContent = $firstNestedHeader.next(
					'.sub-accordion-content'
				);

				// Close any other open sub-accordions
				$content
					.find('.sub-accordion-header')
					.not($firstNestedHeader)
					.removeClass('active')
					.attr('aria-expanded', 'false');
				$content
					.find('.sub-accordion-content')
					.not($firstNestedContent)
					.slideUp(300)
					.attr('aria-hidden', 'true');

				// Open the first nested accordion
				$firstNestedHeader.addClass('active');
				$firstNestedHeader.attr('aria-expanded', 'true');
				$firstNestedContent
					.slideDown(300)
					.attr('aria-hidden', 'false');

				// Focus the first sub-accordion header
				setTimeout(() => {
					$firstNestedHeader.focus();
				}, 300); // Match the slideDown duration
			}
		}
	);

	// Initialize aria-expanded state for all accordions on page load
	$('.main-accordion').each(function () {
		const $accordion = $(this);
		const $header = $accordion.find(
			'.main-accordion-header'
		);
		const $content = $header.next(
			'.main-accordion-content'
		);
		const isExpanded = $header.hasClass('active');
		$accordion.attr(
			'aria-expanded',
			isExpanded ? 'true' : 'false'
		);
		$header.attr(
			'aria-expanded',
			isExpanded ? 'true' : 'false'
		);
		$content.attr(
			'aria-hidden',
			isExpanded ? 'false' : 'true'
		);
	});

	$('.sub-accordion-header').each(function () {
		const $header = $(this);
		const $content = $header.next('.sub-accordion-content');
		const $item = $header.closest('.sub-accordion-item');
		const isExpanded = $header.hasClass('active');
		$header.attr(
			'aria-expanded',
			isExpanded ? 'true' : 'false'
		);
		$item.attr(
			'aria-expanded',
			isExpanded ? 'true' : 'false'
		);
		$content.attr(
			'aria-hidden',
			isExpanded ? 'false' : 'true'
		);
	});

	// Sub-accordion functionality
	$(document).on(
		'click keydown',
		'.sub-accordion-header',
		function (e) {
			// Only trigger on click, space, or enter
			if (
				e.type === 'keydown' &&
				e.keyCode !== 32 &&
				e.keyCode !== 13
			) {
				return;
			}

			e.stopPropagation(); // Prevent triggering parent accordion

			const $header = $(this);
			const $content = $header.next(
				'.sub-accordion-content'
			);
			const $item = $header.closest('.sub-accordion-item');
			const isExpanded = $header.hasClass('active');

			// Find parent accordion content to limit the scope of closing other sub-accordions
			const $parentAccordionContent = $header.closest(
				'.main-accordion-content'
			);

			// If opening this accordion, close all others within the same main accordion
			if (!isExpanded) {
				// Close all other sub-accordions in the same main accordion
				$parentAccordionContent
					.find('.sub-accordion-header')
					.not($header)
					.removeClass('active')
					.attr('aria-expanded', 'false');
				$parentAccordionContent
					.find('.sub-accordion-item')
					.not($item)
					.attr('aria-expanded', 'false');
				$parentAccordionContent
					.find('.sub-accordion-content')
					.not($content)
					.slideUp(300)
					.attr('aria-hidden', 'true');
			}

			// Toggle the clicked accordion
			if (isExpanded) {
				$header.removeClass('active');
				$header.attr('aria-expanded', 'false');
				$item.attr('aria-expanded', 'false');
				$content.slideUp(300).attr('aria-hidden', 'true');
			} else {
				$header.addClass('active');
				$header.attr('aria-expanded', 'true');
				$item.attr('aria-expanded', 'true');
				$content
					.slideDown(300)
					.attr('aria-hidden', 'false');
			}
		}
	);
});

function formatCurrency(price) {
	const currency_separator = theme.currency_separator;
	const currency_format = theme.currency_format;
	const thousand_separator = theme.thousand_separator;
	price = price.toFixed(2).replace('.', currency_separator);
	price =
		price.length > 6
			? price.slice(0, -6) +
			  thousand_separator +
			  price.slice(-6)
			: price;
	price = currency_format.replace('{{amount}}', price);
	return price;
}

$('.modal-close').click(function () {
	$('.modal').hide();
	$('body').css('overflow', 'auto');
});

/*************** Search Function **************/

$('.view-all-search').click(function () {
	searchViewAll();
});

function searchViewAll() {
	var query = $('.searchbox').val();
	query = query.replaceAll('&', '%26');
	query = query.replaceAll(' ', '+');

	// Get the current locale root URL
	const localeRootUrl = window.localeRootUrl || '';
	let searchUrl = (localeRootUrl + '/search?q=' + query + '&type=product').replace('//', '/');

	if (window.theme?.kewGroveSearchFilteringEnabled === true) {
		// Get current Kew/Grove filter from URL first, then fall back to user preference
		const currentUrlParams = new URLSearchParams(window.location.search);
		const currentKewGroveValues = currentUrlParams.getAll('filter.p.m.global.kew_grove');
		const userPreference = localStorage.getItem('kew-grove-preference');

		// Add Kew/Grove filter - prioritize current URL filters over stored preference
		if (currentKewGroveValues.length > 0) {
			// Preserve current Kew/Grove filters from URL
			currentKewGroveValues.forEach(value => {
				searchUrl += '&filter.p.m.global.kew_grove=' + encodeURIComponent(value);
			});
		} else if (userPreference) {
			// Fall back to stored preference if no current filters
			if (userPreference === 'kew') {
				searchUrl +=
					'&filter.p.m.global.kew_grove=kew&filter.p.m.global.kew_grove=kew_grove';
			} else if (userPreference === 'grove') {
				searchUrl +=
					'&filter.p.m.global.kew_grove=grove&filter.p.m.global.kew_grove=kew_grove';
			}
		}
	}

	window.location.href = searchUrl;
}

$(document).on('click', '.search-proditem', function () {
	var producturl = $(this).attr('prod-link');
	
	// Get the search term from the navbar search inputs
	const searchTerm = $('#desktop-search-input').val() || 
		$('.mobile-menu-search-input > input').val() || '';
	
	// Add search term as URL parameter if it exists
	if (searchTerm) {
		const separator = producturl.includes('?') ? '&' : '?';
		const urlWithSearch = `${producturl}${separator}search_term=${encodeURIComponent(searchTerm)}`;
		window.location.href = urlWithSearch;
	} else {
		window.location.href = producturl;
	}
});

// Handle "Add to Cart" button clicks in quick search results
$(document).on('click', '#prodsearch-list .quickbuy, #prodsearch-mobile-list .quickbuy', function (e) {
	// Store search term in sessionStorage for product page to use
	const searchTerm = $('#desktop-search-input').val() || 
		$('.mobile-menu-search-input > input').val() || '';
	
	if (searchTerm) {
		sessionStorage.setItem('lastSearchTerm', searchTerm);
	}
});

document
	.querySelectorAll('.basket-item-remove-button')
	.forEach(function (button) {
		button.addEventListener('click', function (event) {
			event.preventDefault();
			const lineKey = button.getAttribute('data-line-key');
			const basketItem = button.closest('.basket-item');

			// Immediately remove the item from the DOM
			basketItem.remove();

			// Then proceed with the cart update
			const localeRootUrl = window.localeRootUrl || '';
			const cartChangeEndpoint = (localeRootUrl + '/cart/change.js').replace('//', '/');
			fetch(cartChangeEndpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					id: lineKey,
					quantity: 0,
				}),
			})
				.then(response => response.json())
				.then(data => {
					// Update the item count in the header
					const basketItemCount = document.querySelector(
						'.basket-item-count'
					);
					const currentCount = data.item_count;
					basketItemCount.textContent =
						theme.strings.itemsInBasket
							.replace('{{ count }}', currentCount)
							.replace('{{ items }}', currentCount);

					// Update the subtotal
					const basketSubtotal = document.querySelector(
						'.basket-subtotal-amount'
					);
					basketSubtotal.textContent = formatCurrency(
						(data.total_price * theme.vat_rate) / 100
					);

					if (data.item_count === 0) {
						// Show empty basket state
						const basketPanel =
							document.getElementById('basket-panel');
						const basketContent = document.querySelector(
							'.basket-panel-content'
						);
						const emptyBasketContent =
							document.querySelector(
								'.basket-panel-content-empty'
							);

						basketPanel.classList.add('empty-basket-panel');
						basketContent.classList.add(
							'empty-basket-panel'
						);
						if (emptyBasketContent) {
							emptyBasketContent.classList.add('active');
						}

						// Clear the basket content
						basketContent.innerHTML = '';
					}

					// Always update the basket content after removing an item
					updateBasketContent();
				})
				.catch(error => {
					console.error('Error:', error);
				});
		});
	});

$(document).on('click', '.quickbuy', function () {
	if ($(this).is(':disabled')) return;

	const variantid = $(this).attr('variant-id');
	const rrp_price = $(this).attr('data-rrp-price');
	const prodhandle = $(this).attr('data-handle');
	const price = $(this).attr('data-price');
	const isMobile = $(window).width() <= 1024;

	// Check if this was clicked from search results
	const isFromSearch = isMobile
		? $(this).closest('#prodsearch-mobile-list').length > 0
		: $(this).closest('#prodsearch-list').length > 0;
	
	// Also check if we're on a search results page
	const isOnSearchPage = window.location.pathname.includes('/search');

	// If from search results, push to dataLayer
	if (isFromSearch && isOnSearchPage) {
		const productTitle = $(this)
			.closest('.product-grid-item')
			.find('.product-grid-item-title')
			.text()
			.split(' - ')[0]
			.trim();
		const productSku = $(this)
			.closest('.product-grid-item')
			.find('.product-grid-item-title')
			.text()
			.split(' - ')[1]
			.trim();
		const position =
			$(this)
				.closest('.product-grid-item')
				.index('.product-grid-item') + 1;
		const searchTerm =
			$('.search-input').val() ||
			$('#desktop-search-input').val() ||
			$('.mobile-menu-search-input > input').val() ||
			'';

		// Store search term in sessionStorage for product page to use
		if (searchTerm) {
			sessionStorage.setItem('lastSearchTerm', searchTerm);
		}

		// Add search term to URL if not already present
		const currentUrl = window.location.href;
		if (!currentUrl.includes('search_term=')) {
			const separator = currentUrl.includes('?')
				? '&'
				: '?';
			const newUrl = `${currentUrl}${separator}search_term=${encodeURIComponent(
				searchTerm
			)}`;
			window.history.replaceState({}, '', newUrl);
		}

		dataLayer.push({
			event: 'navbar_add_to_basket',
			search_term: searchTerm,
			product_title: productTitle,
			product_sku: productSku,
			product_price: price,
			result_position: position,
		});
	}

	// Initialize basket panel if it doesn't exist
	const basketPanel =
		document.getElementById('basket-panel');
	if (!basketPanel) {
		console.warn('Basket panel not found, creating it...');
		const newBasketPanel = document.createElement('div');
		newBasketPanel.id = 'basket-panel';
		newBasketPanel.className = 'basket-panel';
		newBasketPanel.setAttribute('role', 'dialog');
		newBasketPanel.setAttribute('aria-modal', 'true');
		newBasketPanel.setAttribute(
			'aria-labelledby',
			'basket-panel-title'
		);
		newBasketPanel.setAttribute('aria-hidden', 'true');
		newBasketPanel.setAttribute('inert', '');
		document.body.appendChild(newBasketPanel);
	}

	// Show panel immediately
	$('#basket-panel').removeClass('empty-basket-panel');
	if (typeof openBasketPanel === 'function') {
		openBasketPanel();
	}

	// First check if the product exists in the cart
	const localeRootUrl = window.localeRootUrl || '';
	const cartEndpoint = (localeRootUrl + '/cart.js').replace('//', '/');
	fetch(cartEndpoint)
		.then(response => response.json())
		.then(cart => {
			// A merged bespoke bundle can share this variant id (stock-matched
			// plates are real sellable variants). CartJS.updateItemById posts
			// /cart/change.js with the bare variant id, which on a merged line
			// multiplies the whole bundle and wipes its properties — so if any
			// matching line is a bundle, fall through to addItem instead.
			const matchingLines = cart.items.filter(
				item => item.variant_id === parseInt(variantid)
			);
			const existingItem = matchingLines.some(item => item.has_components)
				? null
				: matchingLines[0];

			if (existingItem) {
				// Update quantity of existing item
				CartJS.updateItemById(
					variantid,
					existingItem.quantity + 1,
					{
						_rrp_price: rrp_price,
					},
					{
						success: function (data) {
							announceCartChange(
								'Item quantity updated in cart'
							);
							updateBasketContent();
						},
					}
				);
			} else {
				// Add new item
				CartJS.addItem(
					variantid,
					1,
					{
						_rrp_price: rrp_price,
					},
					{
						success: function (data) {
							announceCartChange('Item added to cart');
							// Ensure basket panel is properly initialized before updating content
							const basketPanel =
								document.getElementById('basket-panel');
							if (!basketPanel) {
								console.error(
									'Basket panel not found after adding item'
								);
								return;
							}

							// Add a small delay to ensure the panel is fully initialized
							setTimeout(() => {
								updateBasketContent();
							}, 100);
						},
					}
				);
			}
		});
});

$('.mainaddtocart').click(function (e) {
	if ($(this).attr('disabled') === 'disabled') {
		e.preventDefault();
		e.stopPropagation();
		return false;
	}
	var variantid = $(this).attr('variant-id'),
		prodhandle = $(this).attr('data-handle'),
		quantity = $(this)
			.closest('.atb-row-one')
			.find('#product-quantity-top')
			.val();

	var rrp_price = $(this).attr('data-rrp-price');

	// Check if user came from search using URL parameter
	const urlParams = new URLSearchParams(
		window.location.search
	);
	const searchTerm = urlParams.get('search_term');

	// If from search, push to dataLayer
	if (searchTerm) {
		const productTitle = $(this)
			.closest('.product-info')
			.find('.product-info__title-name')
			.text()
			.trim();
		const productSku = $(this)
			.closest('.product-info')
			.find('.product-info__sku')
			.text()
			.trim();
		const price = $(this).attr('data-price');

		dataLayer.push({
			event: 'add_to_cart',
			search_term: searchTerm,
			product_title: productTitle,
			product_sku: productSku,
			product_price: price,
			timestamp: new Date().toISOString(),
		});
	}

	// Only show panel if product is in stock
	if ($(this).not('[disabled]').length) {
		$('#basket-panel').removeClass('empty-basket-panel');
		if (typeof openBasketPanel === 'function') {
			openBasketPanel();
		}
	}

	quantity = parseInt(quantity);
	if (!quantity) {
		quantity = 1;
	}

	if (Number.isInteger(quantity) && quantity > 0) {
		// First check if the product exists in the cart
		const localeRootUrl = window.localeRootUrl || '';
		const cartEndpoint = (localeRootUrl + '/cart.js').replace('//', '/');
		fetch(cartEndpoint)
			.then(response => response.json())
			.then(cart => {
				// Same bundle guard as the drawer add path above: never route a
				// variant-id change at a line that is (or shadows) a merged bundle.
				const matchingLines = cart.items.filter(
					item => item.variant_id === parseInt(variantid)
				);
				const existingItem = matchingLines.some(item => item.has_components)
					? null
					: matchingLines[0];

				if (existingItem) {
					// Update quantity of existing item
					CartJS.updateItemById(
						variantid,
						existingItem.quantity + quantity,
						{
							_rrp_price: rrp_price,
						},
						{
							success: function (data) {
								announceCartChange(
									'Item quantity updated in cart'
								);
								updateBasketContent();
							},
						}
					);
				} else {
					// Add new item
					CartJS.addItem(
						variantid,
						quantity,
						{
							_rrp_price: rrp_price,
						},
						{
							success: function (data) {
								announceCartChange('Item added to cart');
								updateBasketContent();
							},
						}
					);
				}
			});
	}
});

// Add this at the top of the file, outside any function
let basketUpdateRetryCount = 0;
const MAX_RETRIES = 3;

function updateBasketRrpTotal(items) {
	const basketRrpWrapper = document.querySelector('.basket-rrp-total');
	const basketRrpAmount = document.querySelector('.basket-rrp-amount');

	if (!basketRrpWrapper || !basketRrpAmount) {
		return;
	}

	let totalRrp = 0;

	if (Array.isArray(items)) {
		items.forEach(item => {
			const rawRrp =
				item &&
				item.properties &&
				Number(item.properties['_rrp_price']);
			if (!rawRrp || item.price === rawRrp) {
				return;
			}

			const quantity = item.quantity || 0;
			totalRrp += (rawRrp / 100) * quantity * theme.vat_rate;
		});
	}

	if (totalRrp > 0) {
		basketRrpWrapper.style.display = '';
		basketRrpAmount.textContent = formatCurrency(totalRrp);
	} else {
		basketRrpWrapper.style.display = 'none';
		basketRrpAmount.textContent = '';
	}
}

function updateBasketContent() {
	const localeRootUrl = window.localeRootUrl || '';
	const cartEndpoint = (localeRootUrl + '/cart.js').replace('//', '/');
	fetch(cartEndpoint)
		.then(response => response.json())
		.then(cart => {
			// Get all required elements
			const basketPanel =
				document.getElementById('basket-panel');
			const basketContent = document.querySelector(
				'.basket-panel-content'
			);
			const emptyBasketContent = document.querySelector(
				'.basket-panel-content-empty'
			);
			const basketItemCount = document.querySelector(
				'.basket-item-count'
			);
			const basketSubtotal = document.querySelector(
				'.basket-subtotal-amount'
			);
			const kewGroveWarning = document.getElementById(
				'kew-grove-warning'
			);

			// Check for Kew and Grove products
			let hasKew = false;
			let hasGrove = false;

			cart.items.forEach(item => {
				// Check all possible locations for the handle
				const handle =
					item.handle ||
					(item.product && item.product.handle) ||
					(item.url && item.url.split('/').pop());

				if (handle) {
					if (handle.includes('kew-')) {
						hasKew = true;
					}
					if (handle.includes('grove-')) {
						hasGrove = true;
					}
				}
			});

			// Update warning visibility
			if (kewGroveWarning) {
				kewGroveWarning.style.display =
					hasKew && hasGrove ? 'block' : 'none';
			}

			// If basket panel is not found, try to initialize it
			if (!basketPanel) {
				console.warn(
					'Basket panel not found, attempting to initialize...'
				);
				// Trigger the basket panel initialization
				if (typeof openBasketPanel === 'function') {
					openBasketPanel();
					// Reset retry count when initializing panel
					basketUpdateRetryCount = 0;
					// Wait a short moment for the panel to initialize
					setTimeout(() => {
						updateBasketContent();
					}, 100);
				}
				return;
			}

			// If other required elements are missing, try to find them again
			if (!basketContent) {
				if (basketUpdateRetryCount < MAX_RETRIES) {
					console.warn(
						`Some basket elements not found, retrying... (${
							basketUpdateRetryCount + 1
						}/${MAX_RETRIES})`
					);
					basketUpdateRetryCount++;
					setTimeout(() => {
						updateBasketContent();
					}, 100);
				} else {
					console.warn(
						'Maximum retry attempts reached. Basket elements not found.'
					);
					// Reset retry count
					basketUpdateRetryCount = 0;
				}
				return;
			}

			// Reset retry count on successful update
			basketUpdateRetryCount = 0;

			if (cart.items.length === 0) {
				// Show the empty basket content
				basketPanel.classList.add('empty-basket-panel');
				basketContent.classList.add('empty-basket-panel');
				if (emptyBasketContent) {
					emptyBasketContent.classList.add('active');
				}
				// Clear any existing basket items
				const basketProducts = basketContent.querySelector(
					'.basket-products'
				);
				if (basketProducts) {
					basketProducts.innerHTML = '';
				}
			} else {
				// Hide the empty basket content
				basketPanel.classList.remove('empty-basket-panel');
				basketContent.classList.remove(
					'empty-basket-panel'
				);
				if (emptyBasketContent) {
					emptyBasketContent.classList.remove('active');
				}

				// Create new content container
				const newBasketContent =
					document.createElement('div');
				newBasketContent.classList.add('basket-products');

				// Add cart items
				cart.items.forEach(item => {
					const rrp_price = item.properties['_rrp_price'];
					const unitPrice = Number(item.price);
					const unitRrp = Number(rrp_price);
					const showRrp = rrp_price && unitRrp > 0 && unitRrp !== unitPrice;
					newBasketContent.innerHTML += `
						<div class="basket-item" data-rrp-price="${showRrp && rrp_price ? (rrp_price * item.quantity * theme.vat_rate) : '0'}">
							<a href="${item.url}" class="basket-item-link">
								<div class="basket-item-image">    
									${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
								</div>
							</a>
							<div class="basket-item-details">
								<div class="basket-item-details-top">	
									<a href="${item.url}" class="basket-item-title-link">
										<p class="basket-item-title">${
											item.title.split(' - ')[0]
										}</p>
									</a>
									<div class="basket-item-quantity-price-container">
										<div class="basket-item-price-wrapper">
											<p class="basket-item-price">${formatCurrency(
												item.line_price / 100 * theme.vat_rate
											)}</p>
											${
												showRrp
													? `<span class="mobile-only rrp-price">${formatCurrency(
															(rrp_price / 100 * theme.vat_rate) *
																item.quantity
													  )}</span>`
													: ''
											}
										</div>
										<div class="basket-item-quantity-remove-container">
											${item.has_components ? '' : `<div class="basket-item-quantity">
												<span>${theme.strings.quantity}</span>
												<div class="qty-select standalone-qty-select"
													 data-variant-id="${item.variant_id}"
													 data-line-key="${item.key}">
													<input
														class="item-qty-select qty-select-input"
														type="number"
														value="${item.quantity}"
														min="0"
														step="1"
														style="border: none; outline: none; line-height: 0" />
													<div class="qty-select-arrow-container">
														<ul class="qty-select-dropdown">
															${Array.from(
																{ length: 50 },
																(_, i) =>
																	`<li value="${
																		i + 1
																	}" class="option">${
																		i + 1
																	}</li>`
															).join('')}
														</ul>
														<div class="qty-select-arrow"></div>
													</div>
												</div>
											</div>`}
											<a href="#" class="basket-item-remove-button" data-action="remove" data-line-key="${
												item.key
											}">${theme.strings.removeAll}</a>
										</div>
									</div>
								</div>
								<div class="basket-item-details-bottom">
									<div class="basket-item-price-wrapper">
										<p class="basket-item-price">${formatCurrency(
											item.line_price / 100 * theme.vat_rate
										)}</p>
										${
											showRrp
												? `<span class="desktop-only rrp-price">${formatCurrency(
														(rrp_price / 100 * theme.vat_rate) *
															item.quantity
												  )}</span>`
												: ''
										}
									</div>
									<a href="#" class="basket-item-remove-button" data-action="remove" data-line-key="${
										item.key
									}">${theme.strings.removeAll}</a>
								</div>
							</div>
						</div>
					`;
				});

				// Update the basket content
				const existingBasketProducts =
					basketContent.querySelector('.basket-products');
				if (existingBasketProducts) {
					existingBasketProducts.innerHTML =
						newBasketContent.innerHTML;
				} else {
					basketContent.appendChild(newBasketContent);
				}
			}

			// Update cart totals if elements exist
			if (basketItemCount) {
				basketItemCount.textContent =
					theme.strings.itemsInBasket
						.replace('{{ count }}', cart.item_count)
						.replace('{{ items }}', cart.item_count);
			}

			if (basketSubtotal) {
				basketSubtotal.textContent = formatCurrency(
					(cart.total_price * theme.vat_rate) / 100
				);
			}

			updateBasketRrpTotal(cart.items);

			// Reattach remove button event listeners
			document
				.querySelectorAll('.basket-item-remove-button')
				.forEach(function (button) {
					button.addEventListener(
						'click',
						function (event) {
							event.preventDefault();
							const lineKey =
								button.getAttribute('data-line-key');
							const localeRootUrl = window.localeRootUrl || '';
							const cartChangeEndpoint = (localeRootUrl + '/cart/change.js').replace('//', '/');
							fetch(
								cartChangeEndpoint,
								{
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
									},
									body: JSON.stringify({
										id: lineKey,
										quantity: 0,
									}),
								}
							)
								.then(response => response.json())
								.then(data => {
									const basketItem =
										button.closest('.basket-item');
									basketItem.remove();
									// Update the item count in the header
									const basketItemCount =
										document.querySelector(
											'.basket-item-count'
										);
									const currentCount = data.item_count;
									basketItemCount.textContent =
										theme.strings.itemsInBasket
											.replace('{{ count }}', currentCount)
											.replace('{{ items }}', currentCount);
									// Update the subtotal
									const basketSubtotal =
										document.querySelector(
											'.basket-subtotal-amount'
										);
									basketSubtotal.textContent =
										formatCurrency(
											(data.total_price * theme.vat_rate) /
												100
										);

									updateBasketRrpTotal(data.items);

									// Check for Kew and Grove products
									let hasKew = false;
									let hasGrove = false;

									data?.items?.forEach(item => {
										// Check all possible locations for the handle
										const handle =
											item.handle ||
											(item.product &&
												item.product.handle) ||
											(item.url &&
												item.url.split('/').pop());

										if (handle) {
											if (handle.includes('kew-')) {
												hasKew = true;
											}
											if (handle.includes('grove-')) {
												hasGrove = true;
											}
										}
									});

									// Update warning visibility
									const kewGroveWarning =
										document.getElementById(
											'kew-grove-warning'
										);
									if (kewGroveWarning) {
										kewGroveWarning.style.display =
											hasKew && hasGrove ? 'block' : 'none';
									}

									if (data.item_count === 0) {
										// Show empty basket state
										const basketPanel =
											document.getElementById(
												'basket-panel'
											);
										const basketContent =
											document.querySelector(
												'.basket-panel-content'
											);
										const emptyBasketContent =
											document.querySelector(
												'.basket-panel-content-empty'
											);

										basketPanel.classList.add(
											'empty-basket-panel'
										);
										basketContent.classList.add(
											'empty-basket-panel'
										);
										if (emptyBasketContent) {
											emptyBasketContent.classList.add(
												'active'
											);
										}

										// Clear the basket content
										const basketProducts =
											basketContent.querySelector(
												'.basket-products'
											);
										if (basketProducts) {
											basketProducts.innerHTML = '';
										}
									}
								})
								.catch(error => {
									console.error('Error:', error);
								});
						}
					);
				});

			// Reattach continue shopping button event listener
			const continueShoppingBtn = document.querySelector(
				'.basket-continue-shopping'
			);
			if (continueShoppingBtn) {
				continueShoppingBtn.addEventListener(
					'click',
					function (e) {
						e.preventDefault();
						document.body.classList.remove('no-scroll');
						document
							.getElementById('basket-panel')
							.classList.remove('active');
						document
							.querySelector('.panel-overlay')
							.classList.remove('active');
						document
							.querySelector('.navbar')
							.classList.remove('search-open');
					}
				);
			}

			// Initialize quantity selectors
			initQtySelectors();
			$('.qty-select-arrow-container').click(function () {
				qtySelectClick.call(this);
			});
		});
}

$('document').ready(function () {
	$('.qty-select-arrow-container').click(function () {
		qtySelectClick.call(this);
	});
});

function qtySelectClick() {
	const parent = $(this).parent();
	const dropdown = parent.find('.qty-select-dropdown');
	const input = parent.find('.qty-select-input');
	const lineKey = parent.attr('data-line-key');

	// Toggle dropdown visibility
	if (dropdown.hasClass('active')) {
		dropdown.removeClass('active');
		return;
	}

	dropdown.addClass('active');

	// Handle clicks on dropdown options
	dropdown.find('.option').click(function (e) {
		e.stopPropagation();
		const value = $(this).attr('value');
		const newQuantity = parseInt(value);
		input.val(value).trigger('change');
		updateCartQuantity(lineKey, newQuantity, parent[0]);
		dropdown.removeClass('active');
	});

	// Handle clicks outside the dropdown
	$(document).on('click.qtySelect', function (e) {
		if (!parent[0].contains(e.target)) {
			dropdown.removeClass('active');
			$(document).off('click.qtySelect');
		}
	});
}

if (parent !== window) {
	$('body').addClass('iframe');
}
if (
	window.location.hostname === 'localhost' ||
	window.location.hostname === '127.0.0.1'
) {
	$('body').addClass('local');
}

/* Collection Carousel */
$(document).ready(function () {
	$('.collection-carousel.play').slick({
		dots: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		arrows: false,
		autoplay: false,
		fade: true,
	});

	let collectionCarouselInterval = setInterval(function () {
		$('.collection-carousel.play').slick('slickNext');
	}, 2000);

	$('.collection-carousel.play>.slick-dots').on(
		'click',
		function () {
			clearInterval(collectionCarouselInterval);
		}
	);
});

// Add this function at the top level of the theme.js file
function initQtySelectors() {
	document
		.querySelectorAll('.qty-select.standalone-qty-select')
		.forEach(select => {
			const input = select.querySelector(
				'.qty-select-input'
			);
			const dropdown = select.querySelector(
				'.qty-select-dropdown'
			);
			const arrowContainer = select.querySelector(
				'.qty-select-arrow-container'
			);
			const lineKey = select.dataset.lineKey;

			// Remove any existing event listeners to prevent duplicates
			const newArrowContainer =
				arrowContainer.cloneNode(true);
			arrowContainer.parentNode.replaceChild(
				newArrowContainer,
				arrowContainer
			);
			const newDropdown = dropdown.cloneNode(true);
			dropdown.parentNode.replaceChild(
				newDropdown,
				dropdown
			);

			// Toggle dropdown
			newArrowContainer.addEventListener('click', e => {
				e.stopPropagation();
				newDropdown.classList.toggle('active');
				newArrowContainer.classList.toggle('active');
			});

			// Close dropdown when clicking outside
			document.addEventListener('click', e => {
				if (!select.contains(e.target)) {
					newDropdown.classList.remove('active');
					newArrowContainer.classList.remove('active');
				}
			});

			// Handle quantity selection from dropdown
			newDropdown
				.querySelectorAll('.option')
				.forEach(option => {
					option.addEventListener('click', e => {
						e.stopPropagation();
						const newQuantity = parseInt(
							option.getAttribute('value')
						);
						input.value = newQuantity;
						updateCartQuantity(
							lineKey,
							newQuantity,
							select
						);
						newDropdown.classList.remove('active');
						newArrowContainer.classList.remove('active');
					});
				});

			// Handle direct input changes
			input.addEventListener('change', () => {
				const newQuantity = parseInt(input.value);
				if (!isNaN(newQuantity) && newQuantity >= 0) {
					updateCartQuantity(lineKey, newQuantity, select);
				}
			});

			// Handle input blur to ensure changes are saved
			input.addEventListener('blur', () => {
				const newQuantity = parseInt(input.value);
				if (!isNaN(newQuantity) && newQuantity >= 0) {
					updateCartQuantity(lineKey, newQuantity, select);
				}
			});
		});
}

initQtySelectors();

// A merged bespoke bundle is a quantity-1 object in Shopify: any /cart/change.js
// or /cart/update.js on the merged key MULTIPLIES the hidden source lines by the
// posted quantity instead of setting a count (verified live, 2026-08-06 — see
// corston-command-centre briefings/bespoke-bundle-quantity-set-to-q.md). "Set to
// Q" therefore re-adds the per-bundle composition ×Q under a fresh _bundle_id and
// only then removes the old merged line — add-first, so a failure can never lose
// the customer's bespoke configuration (worst case is a visible duplicate row).
// The composition comes from Liquid via data-bundle-payload (line-standard);
// the Cart AJAX API never exposes component lines, so it can't be rebuilt here.
function setBundleQuantity(bundleWrap, newCount, select) {
	newCount = parseInt(newCount, 10);
	const oldKey = bundleWrap.dataset.bundleLineKey;
	const currentCount = parseInt(bundleWrap.dataset.bundleCount, 10) || 1;
	const input = select && select.querySelector('.qty-select-input');
	// The dropdown handler fires updateCartQuantity twice (input change + direct
	// call); an in-flight update just swallows the echo without touching the input.
	if (bundleWrap.dataset.bundleBusy) return;
	if (isNaN(newCount) || newCount < 0 || newCount === currentCount) {
		if (input) input.value = currentCount;
		return;
	}
	bundleWrap.dataset.bundleBusy = 'true';
	if (input) input.disabled = true;

	const localeRootUrl = window.localeRootUrl || '';
	const changeEndpoint = (localeRootUrl + '/cart/change.js').replace('//', '/');
	const addEndpoint = (localeRootUrl + '/cart/add.js').replace('//', '/');
	const removeOld = () =>
		fetch(changeEndpoint, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: oldKey, quantity: 0 }),
		}).then(res => {
			// fetch resolves on 404/422 too — a failed removal would otherwise
			// reload silently with both the old and new bundle rows in the cart.
			if (!res.ok) {
				throw new Error(
					'Cart error ' + res.status + ' removing the previous bundle'
				);
			}
			return res;
		});

	// Setting to 0 = remove the whole bundle (zeroing the merged key cleanly
	// removes every component — verified live, 2026-08-06).
	if (newCount === 0) {
		removeOld().then(
			() => window.location.reload(),
			() => window.location.reload()
		);
		return;
	}

	let components;
	try {
		components = JSON.parse(bundleWrap.dataset.bundlePayload);
	} catch (err) {
		console.error('Bespoke bundle: unreadable composition payload', err);
		delete bundleWrap.dataset.bundleBusy;
		if (input) {
			input.disabled = false;
			input.value = currentCount;
		}
		return;
	}

	// Same id format as the builder (switch-builder.js newBundleId). A fresh id
	// keeps the re-added lines from mixing with the still-present old group.
	const freshBundleId =
		'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
	const items = components.map(component => {
		// Liquid's `properties | json` may serialise the hash as key/value pairs.
		const props = Array.isArray(component.properties)
			? Object.fromEntries(component.properties)
			: Object.assign({}, component.properties || {});
		props['_bundle_id'] = freshBundleId;
		return {
			id: component.id,
			quantity: component.quantity * newCount,
			properties: props,
		};
	});

	fetch(addEndpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({ items: items }),
	})
		.then(res => {
			if (res.ok) return res;
			// Shopify's cart 422 body carries the human-readable reason
			// (usually a sold-out component) — surface it, not a bare status.
			return res
				.json()
				.catch(() => null)
				.then(body => {
					const detail = body && (body.description || body.message);
					throw new Error(detail || 'Cart error ' + res.status);
				});
		})
		.then(removeOld)
		.then(() => window.location.reload())
		.catch(err => {
			console.error('Bespoke bundle: set quantity failed', err);
			alert(
				(err && err.message) ||
					'Sorry, there was a problem updating the quantity. Please try again.'
			);
			// Reload restores the true cart state (including the selector value,
			// and any duplicate row if only the removal failed).
			window.location.reload();
		});
}

// Update the updateCartQuantity function
function updateCartQuantity(lineKey, quantity, select) {
	// Bundle rows carry their composition on a wrapper; every qty-change path
	// (dropdown, typed input, blur, jQuery arrow handler) funnels through here,
	// so this one intercept keeps the multiplying /cart/change.js off merged keys.
	const bundleWrap = select && select.closest('[data-bundle-payload]');
	if (bundleWrap) {
		setBundleQuantity(bundleWrap, quantity, select);
		return;
	}
	const localeRootUrl = window.localeRootUrl || '';
	const cartChangeEndpoint = (localeRootUrl + '/cart/change.js').replace('//', '/');
	fetch(cartChangeEndpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			id: lineKey,
			quantity: quantity,
		}),
	})
		.then(response => response.json())
		.then(data => {
			// Update the input value first
			select.querySelector('.qty-select-input').value =
				quantity;

			// Find the updated item in cart data
			const updatedItem = data?.items?.find(
				item => item.key === lineKey
			);

			// Announce the change to screen readers
			if (quantity === 0) {
				announceCartChange('Item removed from cart');
			} else {
				announceCartChange(
					`Quantity updated to ${quantity}`
				);
			}

			// Update individual item price displays (drawer: .basket-item; full cart page: .cart-item)
			if (updatedItem) {
				const formattedPrice = formatCurrency(
					(updatedItem.line_price * theme.vat_rate) / 100
				);
				const rrpPrice = updatedItem.properties['_rrp_price'];
				const unitPrice = Number(updatedItem.price);
				const unitRrp = Number(rrpPrice);
				const showRrpRow =
					!!(rrpPrice && unitRrp > 0 && unitRrp !== unitPrice);

				const basketItem = select.closest('.basket-item');
				const cartItem = select.closest('.cart-item');

				if (basketItem) {
					const priceElements = basketItem.querySelectorAll(
						'.basket-item-price'
					);

					priceElements.forEach(priceElement => {
						const priceValueElement =
							priceElement.querySelector(
								'.basket-item-price-value'
							);
						if (priceValueElement) {
							priceValueElement.textContent = formattedPrice;
						} else {
							priceElement.innerHTML = `<span class="basket-item-price-value">${formattedPrice}</span>`;
						}
					});

					// Update RRP price if it exists, user is B2B, and price differs from RRP
					const basketProducts =
						basketItem.closest('.basket-products');
					const isB2B = basketProducts
						? !basketProducts.classList.contains('not-b2b')
						: true; // Default to B2B for cart page
					const showRrp =
						rrpPrice &&
						isB2B &&
						Number(updatedItem.price) !== Number(rrpPrice);

					const rrpElements =
						basketItem.querySelectorAll('.rrp-price');
					rrpElements.forEach(element => {
						if (showRrp) {
							element.style.display = '';
							element.textContent = formatCurrency(
								(rrpPrice / 100) * quantity
							);
						} else {
							element.style.display = 'none';
						}
					});
			}
			}

			// Update cart totals
			const basketItemCount = document.querySelector(
				'.basket-item-count'
			);
			const basketSubtotal = document.querySelector(
				'.basket-subtotal-amount'
			);

			if (basketItemCount) {
				basketItemCount.textContent =
					theme.strings.itemsInBasket
						.replace('{{ count }}', data.item_count)
						.replace('{{ items }}', data.item_count);
			}

			if (basketSubtotal) {
				basketSubtotal.textContent = formatCurrency(
					(data.total_price * theme.vat_rate) / 100
				);
			}

			updateBasketRrpTotal(data.items);

			// Update cart page totals
			const cartSubtotalElement = document.querySelector('.order-summary-grid .summary-row:first-child span:last-child');
			const cartTotalElement = document.querySelector('.order-summary-grid .total-row span:last-child');
			
			if (cartSubtotalElement) {
				const subtotalExclVat = data.total_price / theme.vat_rate;
				cartSubtotalElement.textContent = formatCurrency(subtotalExclVat / 100);
			}
			
			if (cartTotalElement) {
				cartTotalElement.textContent = formatCurrency((data.total_price * theme.vat_rate) / 100);
			}

			// Remove item if quantity is 0
			if (quantity === 0) {
				select.closest('.basket-item')?.remove();
				select.closest('.cart-item')?.remove();
			}
		})
		.catch(console.error);
}

// Create and open trade application form modal
$('a[href="#trade-app-form"]').click(function () {
	const modal = $('#trade-app-form-modal');
	modal.toggleClass('active');
});

// Track when search results are clicked - only when clicking the image link
document.addEventListener('click', function (e) {
	// Check if the clicked element is an image link within a product grid item
	const imageLink = e.target.closest(
		'.product-grid-item .image-link'
	);
	if (imageLink) {
		const searchResult = imageLink.closest(
			'.product-grid-item'
		);
		if (searchResult) {
			// Check if we're on a search results page OR in quick search results
			const isOnSearchPage = window.location.pathname.includes('/search');
			const isInQuickSearch = searchResult.closest('#prodsearch-list, #prodsearch-mobile-list');
			
			if (isOnSearchPage || isInQuickSearch) {
				// Prevent default navigation
				e.preventDefault();

				const productUrl = imageLink.getAttribute('href');
				const currentSearchQuery =
					$('.search-input').val() ||
					$('#desktop-search-input').val() ||
					$('.mobile-menu-search-input > input').val() ||
					'';

				// Store search term in sessionStorage for product page to use
				if (currentSearchQuery) {
					sessionStorage.setItem('lastSearchTerm', currentSearchQuery);
				}

				// Add search term as URL parameter
				const separator = productUrl.includes('?')
					? '&'
					: '?';
				const urlWithSearch = `${productUrl}${separator}search_term=${encodeURIComponent(
					currentSearchQuery
				)}`;

				// Navigate after a small delay to ensure dataLayer push completes
				setTimeout(() => {
					window.location.href = urlWithSearch;
				}, 100);
			}
		}
	}
});

// Add Enter key functionality to desktop search input
$(document).on(
	'keydown',
	'.desktop-search-input',
	function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			const query = $(this).val().trim();
			if (query !== '') {
				// Get the current locale root URL
				const localeRootUrl = window.localeRootUrl || '';
				let searchUrl = (localeRootUrl + '/search?q=' + encodeURIComponent(query) + '&type=product').replace('//', '/');

				if (window.theme?.kewGroveSearchFilteringEnabled === true) {
					// Get user's Kew/Grove preference
					const userPreference = localStorage.getItem(
						'kew-grove-preference'
					);

					// Add Kew/Grove filter based on user preference
					if (userPreference) {
						if (userPreference === 'kew') {
							searchUrl +=
								'&filter.p.m.global.kew_grove=kew&filter.p.m.global.kew_grove=kew_grove';
						} else if (userPreference === 'grove') {
							searchUrl +=
								'&filter.p.m.global.kew_grove=grove&filter.p.m.global.kew_grove=kew_grove';
						}
					}
				}

				window.location.href = searchUrl;
			}
		}
	}
);

// Add Enter key handler for mobile search input
$(document).on(
	'keydown',
	'.mobile-menu-search-input input',
	function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			const query = $(this).val().trim();
			if (query !== '') {
				// Get the current locale root URL
				const localeRootUrl = window.localeRootUrl || '';
				let searchUrl = (localeRootUrl + '/search?q=' + encodeURIComponent(query) + '&type=product').replace('//', '/');

				if (window.theme?.kewGroveSearchFilteringEnabled === true) {
					// Get user's Kew/Grove preference
					const userPreference = localStorage.getItem(
						'kew-grove-preference'
					);

					// Add Kew/Grove filter based on user preference
					if (userPreference) {
						if (userPreference === 'kew') {
							searchUrl +=
								'&filter.p.m.global.kew_grove=kew&filter.p.m.global.kew_grove=kew_grove';
						} else if (userPreference === 'grove') {
							searchUrl +=
								'&filter.p.m.global.kew_grove=grove&filter.p.m.global.kew_grove=kew_grove';
						}
					}
				}

				window.location.href = searchUrl;
			}
		}
	}
);

// Function to trap focus within a modal element
function trapFocus(element) {
	const focusableElements = Array.from(
		element.querySelectorAll(
			'a[href], button, textarea, input[type="text"], input[type="checkbox"], input[type="radio"], select, [tabindex]:not([tabindex="-1"])'
		)
	).filter(el => {
		// Filter out hidden elements
		const style = window.getComputedStyle(el);
		return (
			style.display !== 'none' &&
			style.visibility !== 'hidden' &&
			style.opacity !== '0'
		);
	});

	if (focusableElements.length === 0) return;

	const firstElement = focusableElements[0];
	const lastElement =
		focusableElements[focusableElements.length - 1];

	// Remove any existing keydown listeners
	element.removeEventListener('keydown', handleKeydown);

	function handleKeydown(e) {
		if (e.key === 'Tab') {
			// Always prevent default tab behavior
			e.preventDefault();

			// Get the current index of the active element
			const currentIndex = focusableElements.indexOf(
				document.activeElement
			);

			if (e.shiftKey) {
				// If shift + tab
				if (currentIndex <= 0) {
					// If we're at the first element or not found, go to last
					lastElement.focus();
				} else {
					// Go to previous element
					focusableElements[currentIndex - 1].focus();
				}
			} else {
				// If tab
				if (
					currentIndex === -1 ||
					currentIndex === focusableElements.length - 1
				) {
					// If we're at the last element or not found, go to first
					firstElement.focus();
				} else {
					// Go to next element
					focusableElements[currentIndex + 1].focus();
				}
			}
		}
	}

	// Add the keydown listener
	element.addEventListener('keydown', handleKeydown);

	// Add a click listener to ensure focus stays within the panel
	element.addEventListener('click', e => {
		if (!element.contains(document.activeElement)) {
			firstElement.focus();
		}
	});

	// Focus the first element
	firstElement.focus();
}

function openBasketPanel() {
	const basketPanel = document.getElementById('basket-panel');
	const basketOverlay = document.querySelector('.panel-overlay');
	const basketCloseButton = document.querySelector('.basket-panel-close');

	if (!basketPanel) {
		console.warn('Basket panel not found');
		return;
	}

	document.body.classList.add('no-scroll');
	basketPanel.classList.add('active');
	if (basketOverlay) basketOverlay.classList.add('active');

	// Update ARIA attributes when opening panel
	basketPanel.setAttribute('aria-hidden', 'false');
	// Remove inert attribute to allow focus
	basketPanel.removeAttribute('inert');

	// Set focus to the close button when panel opens
	setTimeout(() => {
		if (basketCloseButton) basketCloseButton.focus();
		// Initialize focus trap after panel is fully opened
		trapFocus(basketPanel);
	}, 100);
}

// Add cart update listener
document.addEventListener(
	'cart.requestComplete',
	function (event) {
		const basketPanel = document.getElementById('basket-panel');
		if (basketPanel && basketPanel.classList.contains('active')) {
			updateBasketContent();
		}

		// Update basket count
		updateBasketCount();
	}
);

// Listen for AJAX cart update events
document.addEventListener(
	'ajaxCart.afterCartLoad',
	function (event) {
		updateBasketCount();
	}
);

// Listen for AJAX cart add events
document.addEventListener(
	'ajaxCart.afterAdd',
	function (event) {
		updateBasketCount();
	}
);

// Listen for AJAX cart update events
document.addEventListener(
	'ajaxCart.afterUpdate',
	function (event) {
		updateBasketCount();
	}
);

// Function to update basket count
function updateBasketCount() {
	// Only update if the page is fully loaded and we're not in an error state
	if (document.readyState !== 'complete') {
		return;
	}

	const localeRootUrl = window.localeRootUrl || '';
	const cartEndpoint = (localeRootUrl + '/cart.js').replace('//', '/');
	fetch(cartEndpoint)
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		})
		.then(cart => {
			const basketCounts =
				document.querySelectorAll('.basket-count');
			basketCounts.forEach(count => {
				const itemCount = cart.item_count;
				count.textContent =
					itemCount > 99 ? '99+' : itemCount;
				if (itemCount === 0) {
					count.style.display = 'none';
				} else {
					count.style.display = 'flex';
				}
			});
		})
		.catch(error => {
			// Only log errors that aren't network-related or expected
			if (error.name !== 'TypeError' && error.name !== 'NetworkError') {
				console.error('Error updating basket count:', error);
			}
		});
}

// Initialize basket count on page load
document.addEventListener('DOMContentLoaded', function () {
	// Add a small delay to ensure everything is loaded
	setTimeout(updateBasketCount, 500);
});

// Update basket count less frequently to reduce network load
let basketUpdateInterval;
document.addEventListener('DOMContentLoaded', function () {
	// Start the interval only after DOM is loaded
	basketUpdateInterval = setInterval(updateBasketCount, 5000); // Changed from 1000ms to 5000ms
});

// Clean up interval when page is unloaded
window.addEventListener('beforeunload', function () {
	if (basketUpdateInterval) {
		clearInterval(basketUpdateInterval);
	}
});

// Fade Up In View Animation - Lightweight Intersection Observer
// Adds 'in-view' class to elements with 'fade-up-in-view' class when they scroll into viewport
// Performance: Intersection Observer is highly optimized, runs off main thread, and unobserve after animation

(function() {
	'use strict';
	
	// Respect user's motion preferences
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (prefersReducedMotion) {
		// If user prefers reduced motion, make all fade-up-in-view elements visible immediately
		document.addEventListener('DOMContentLoaded', function() {
			const elements = document.querySelectorAll('.fade-up-in-view');
			elements.forEach(el => el.classList.add('in-view'));
		});
		return;
	}
	
	// Initialize Intersection Observer when DOM is ready
	function initFadeUpInView() {
		// Only observe elements that don't already have 'in-view' class
		const elements = document.querySelectorAll('.fade-up-in-view:not(.in-view)');
		
		if (elements.length === 0) return;
		
		// Single observer instance for all elements (better performance)
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Add 'in-view' class to trigger CSS transition
					entry.target.classList.add('in-view');
					// Unobserve after animation triggers (performance optimization)
					observer.unobserve(entry.target);
				}
			});
		}, {
			// Trigger when element is 10% visible (early trigger for smooth animation)
			threshold: 0.1,
			// Start animation 50px before element enters viewport
			rootMargin: '50px 0px'
		});
		
		// Observe only new elements that haven't been animated yet
		elements.forEach(el => observer.observe(el));
	}
	
	// Run on DOM ready or immediately if DOM already loaded
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFadeUpInView);
	} else {
		initFadeUpInView();
	}
	
	// Also handle dynamically added content (e.g., AJAX-loaded products)
	// You can call initFadeUpInView() again after adding new content if needed
	window.initFadeUpInView = initFadeUpInView;
})();
